import { useSvgTemplate } from "../hooks";

interface ItemRendererProps {
	item: Style | ColorTypes;
	src?: string;
	filterId: string;
	haveDropShadow?: boolean;
	opacity?: string;
}

const ItemRenderer: React.FC<ItemRendererProps> = ({
	item,
	src,
	filterId,
	haveDropShadow = false,
	opacity = 1,
}) => {
	const svgContent = src
		? useSvgTemplate(src)
		: useSvgTemplate((item as Style).style!);

	if (!svgContent) {
		return null;
	}

	const dropShadowFilter = haveDropShadow ? "url(#drop-shadow)" : "";

	return (
		<g
			dangerouslySetInnerHTML={{ __html: svgContent }}
			className="accessory"
			filter={`url(#${filterId}) ${dropShadowFilter}`}
			opacity={opacity}
		/>
	);
};

export default ItemRenderer;
